// FUncion para consumir las imagenes del backend y convertirlas en un formato que pueda ser mostrado en el frontend
import { API_BASE } from "../config/api-url";

const FALLBACK_IMAGE_URL = "/helmet.svg";
const BLOCKED_IMAGE_HOSTS = new Set(["example.com", "www.example.com"]);

export function getImageUri(imagePath: string | null | undefined): string | undefined {
	if (!imagePath) return undefined;

	const trimmedPath = imagePath.trim();
	const isAbsolute = /^(https?:|file:|content:|data:)/i.test(trimmedPath);
	if (isAbsolute) {
		if (/^https?:/i.test(trimmedPath)) {
			try {
				const parsedUrl = new URL(trimmedPath);
				if (BLOCKED_IMAGE_HOSTS.has(parsedUrl.hostname.toLowerCase())) {
					return FALLBACK_IMAGE_URL;
				}
			} catch {
				return FALLBACK_IMAGE_URL;
			}
		}
		return trimmedPath;
	}

	const normalizedPath = trimmedPath
		.replace(/^\.?\/+/, "")
		.replace(/^app\/uploads\/+/, "")
		.replace(/^uploads\/+/, "");

	if (!normalizedPath) return undefined;

	const cleanBase = API_BASE.replace(/\/$/, "");
	return `${cleanBase}/app/uploads/${normalizedPath}`;
}
